// extracted by mini-css-extract-plugin
export default {"brand":"eRXKO","link":"Z1Odv"};